import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import "./../../../../assets/css/general/Homelayout/CodeChallenge/CodeChallenge.css";

const CodeArena = () => {
  const navigate = useNavigate();
  const [code] = useState(
    "function greet(name) {\n  return `Hello, ${name}!`;\n}",
  );
  const [activeHint, setActiveHint] = useState(null);

  const hints = {
    hint: "Consider returning a string that combines 'Hello' with the name parameter.",
    debug:
      "Check whether the function returns a value. The return keyword may be missing.",
    simplify:
      "This approach works. Template literals could make the string concatenation more direct.",
  };

  return (
    <section className="cc-code-arena">
      <Container className="cc-arena-container">
        <Row>
          <Col xs={12}>
            <div className="cc-arena-header">
              <span className="cc-section-label">Code Arena</span>
              <h2 className="cc-arena-heading">
                Practice coding without pressure
              </h2>
              <p className="cc-arena-subtext">
                Work through problems at your own pace. Each attempt builds
                understanding.
              </p>
            </div>
          </Col>
        </Row>

        <div className="cc-arena-workspace">
          <Row className="cc-workspace-row">
            <Col xs={12} lg={6}>
              <div className="cc-problem-column">
                <div className="cc-problem-meta">
                  <span className="cc-problem-category">
                    String Manipulation
                  </span>
                  <span className="cc-problem-language">JavaScript</span>
                </div>

                <div className="cc-problem-header">
                  <h3 className="cc-problem-title">
                    Create a Greeting Function
                  </h3>
                  <span className="cc-difficulty-badge">Foundational</span>
                </div>

                <div className="cc-problem-description">
                  <p>
                    Write a function that takes a person's name and returns a
                    friendly greeting. For example, if the name is "Alex", your
                    function should return "Hello, Alex!".
                  </p>
                </div>

                <div className="cc-progress-hint">
                  <svg
                    className="cc-hint-icon"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M8 14A6 6 0 108 2a6 6 0 000 12z"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                    <path
                      d="M8 11V8M8 5h.01"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                  </svg>
                  <span>Example from your practice history</span>
                </div>

                <div className="cc-ai-support">
                  <p className="cc-support-label">AI assistance includes:</p>
                  <div className="cc-support-actions">
                    <button
                      className="cc-support-btn preview-only"
                      onClick={() =>
                        setActiveHint(activeHint === "hint" ? null : "hint")
                      }
                    >
                      Need a hint?
                    </button>
                    <button
                      className="cc-support-btn preview-only"
                      onClick={() =>
                        setActiveHint(activeHint === "debug" ? null : "debug")
                      }
                    >
                      Why isn't this working?
                    </button>
                    <button
                      className="cc-support-btn preview-only"
                      onClick={() =>
                        setActiveHint(
                          activeHint === "simplify" ? null : "simplify",
                        )
                      }
                    >
                      Can this be simpler?
                    </button>
                  </div>

                  {activeHint && (
                    <div className="cc-hint-message">
                      <svg
                        className="cc-message-icon"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <circle
                          cx="10"
                          cy="10"
                          r="8"
                          stroke="currentColor"
                          strokeWidth="1.5"
                        />
                        <path
                          d="M10 14v-4m0-3h.01"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                        />
                      </svg>
                      <p>{hints[activeHint]}</p>
                    </div>
                  )}
                </div>
              </div>
            </Col>

            <Col xs={12} lg={6}>
              <div className="cc-editor-column">
                <div className="cc-editor-header">
                  <span className="cc-editor-label">Editor</span>
                  <span className="cc-preview-badge">Preview</span>
                </div>
                <div className="cc-code-editor">
                  <textarea
                    value={code}
                    readOnly
                    className="cc-code-input"
                    spellCheck="false"
                  />
                </div>
                <div className="cc-editor-footer">
                  <a
                    href="#"
                    onClick={() => navigate("/code-arena")}
                    className="cc-workspace-link"
                  >
                    Open in Code Arena
                  </a>
                  <span className="cc-footer-note">
                    Full practice available in the Code Arena
                  </span>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
};

export default CodeArena;
